// Onglet PC IA — raccourcis vers tous les outils de la machine kermhitaa (usine GPU).
// Tailnet-only : nécessite Tailscale actif sur l'appareil. Les tuiles ouvrent l'outil dans un nouvel onglet
// (embed direct impossible : Hub HTTPS vs outils HTTP tailnet = mixed content + X-Frame-Options).

const HOST = "kermhitaa.tail3ea350.ts.net"

type Tool = {
  name: string
  icon: string
  desc: string
  url: string
  tag: string
  accent: string
}

const TOOLS: Tool[] = [
  { name: "MeshCentral (parc)", icon: "🖥️", desc: "Prendre la main à distance sur les PC : écran, logiciels, terminal, fichiers (serveur sur le VPS)", url: "https://srv836585.tail3ea350.ts.net:4430", tag: "Parc", accent: "#0891b2" },
  { name: "Dashboard", icon: "🏠", desc: "Page d'accueil de tous les outils", url: `http://${HOST}:8080`, tag: "Accueil", accent: "#3b82f6" },
  { name: "Réglages MEGAPORT", icon: "⚙️", desc: "Contrôle+supervision : marche/arrêt des outils, CPU/RAM, logs, ÉTEINDRE le PC", url: `https://${HOST}:9090`, tag: "Admin", accent: "#f43f5e" },
  { name: "Arcane", icon: "🐳", desc: "Gérer les conteneurs Docker (start/stop)", url: `http://${HOST}:3552`, tag: "Docker", accent: "#06b6d4" },
  { name: "Hermes WebUI", icon: "⚡", desc: "Agent Hermes", url: `http://${HOST}:8787`, tag: "Agent", accent: "#f59e0b" },
  { name: "OpenFox", icon: "🦊", desc: "Agent coding (gemma4:12b local)", url: `http://${HOST}:10369`, tag: "Agent", accent: "#fb923c" },
  { name: "OpenDesign", icon: "🎨", desc: "Design / UI", url: `http://${HOST}:7456`, tag: "Design", accent: "#a855f7" },
  { name: "Fichiers (PC entier)", icon: "📂", desc: "Tout MEGAPORT + disques à distance ; échange de fichiers (Kermhit/Echange). Système en lecture seule", url: `http://${HOST}:8085`, tag: "Fichiers", accent: "#eab308" },
  { name: "Cartes (moniteur)", icon: "🎚️", desc: "5070 + Arc en direct : mémoire, activité, température, consommation, modèle chargé", url: `http://${HOST}:8086`, tag: "IA", accent: "#f97316" },
  { name: "Modèles IA (llama-swap)", icon: "🎛️", desc: "Quel modèle tourne sur quelle carte (5070 / Arc), journaux en direct", url: `http://${HOST}:8070/ui/`, tag: "IA", accent: "#8b5cf6" },
  { name: "Kirajean local", icon: "🧩", desc: "Agent Jean sur MEGAPORT — modèles locaux via llama-swap", url: `http://${HOST}:8090`, tag: "Agent", accent: "#14b8a6" },
  { name: "ComfyUI", icon: "🖼️", desc: "Image par nœuds — Flux + Qwen-Image 2.1 (création/modification)", url: `http://${HOST}:8188`, tag: "Image", accent: "#22c55e" },
  { name: "Forge", icon: "🔥", desc: "Image simple — Flux + SDXL", url: `http://${HOST}:7860`, tag: "Image", accent: "#ef4444" },
  { name: "Immich", icon: "📸", desc: "Photos/vidéos (catalogue disques)", url: `http://${HOST}:2283`, tag: "Disques", accent: "#0ea5e9" },
  { name: "Grist", icon: "📋", desc: "Tables/notes du catalogue disques", url: `http://${HOST}:8484`, tag: "Disques", accent: "#84cc16" },
]

export default function PcIaPage() {
  return (
    <div style={{ height: "100%", overflowY: "auto", backgroundColor: "#111827" }}>
    <div style={{ padding: "24px", maxWidth: "1000px", margin: "0 auto" }}>
      <div style={{ marginBottom: "8px" }}>
        <h1 style={{ margin: 0, fontSize: "24px", color: "#e6edf3" }}>🏭 PC MEGAPORT (kermhitaa)</h1>
        <p style={{ color: "#8b949e", fontSize: "13px", marginTop: "6px" }}>
          L'usine GPU locale. Tailnet-only : <b>Tailscale doit être actif</b> sur ton appareil. Clique une tuile pour ouvrir l'outil.
        </p>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: "16px", marginTop: "20px" }}>
        {TOOLS.map((t) => (
          <a key={t.name} href={t.url} target="_blank" rel="noreferrer"
            style={{
              display: "block", padding: "18px", borderRadius: "14px", background: "#161b22",
              border: "1px solid #30363d", textDecoration: "none", color: "#e6edf3", transition: "all .15s"
            }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = t.accent; e.currentTarget.style.transform = "translateY(-2px)" }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#30363d"; e.currentTarget.style.transform = "translateY(0)" }}
          >
            <div style={{ fontSize: "30px" }}>{t.icon}</div>
            <div style={{ fontWeight: 600, fontSize: "17px", margin: "8px 0 3px" }}>{t.name}</div>
            <div style={{ color: "#8b949e", fontSize: "12px", lineHeight: 1.4 }}>{t.desc}</div>
            <span style={{ display: "inline-block", fontSize: "10px", padding: "2px 8px", borderRadius: "20px", background: "#21262d", color: "#8b949e", marginTop: "10px" }}>{t.tag}</span>
          </a>
        ))}
      </div>

      <div style={{ marginTop: "28px", padding: "16px", borderRadius: "12px", background: "#161b22", border: "1px solid #30363d", color: "#8b949e", fontSize: "13px", lineHeight: 1.6 }}>
        <b style={{ color: "#e6edf3" }}>ℹ️ Aide-mémoire</b><br />
        • Tous les outils sont <b>toujours allumés</b> (démarrage auto). Tu cliques → ça s'ouvre.<br />
        • <b>Démarrer / arrêter / éteindre le PC</b> à distance → tuile <b>⚙️ Réglages MEGAPORT</b>.<br />
        • <b>Ollama</b> (LLM local gemma4:12b) sert les agents en coulisse (pas de page — API 11434).<br />
        • Si une tuile ne s'ouvre pas : vérifie que <b>Tailscale est actif</b> sur ton appareil.
      </div>
    </div>
    </div>
  )
}
